import React, { useEffect } from "react";
import MortgageShareApplication from "@/model/interface/MortgageShareApplication";
import { formatNumber } from "@/util/sums";
import { formatDate } from "@/util/date";

interface PreviewStepProps {
  mortgageShareApplication: MortgageShareApplication;
}

const PreviewStep: React.FC<PreviewStepProps> = (props) => {
  const { mortgageShareApplication } = props;
  useEffect(() => {
    console.log(mortgageShareApplication);
  }, [mortgageShareApplication]);

  return (
    <div className="content">
      <div className="bg-[#E6F9F2] border-2 border-[#00d184] px-5 py-2.5 text-[#2b2b2b]">
        <div className="flex flex-wrap">
          <h4>Mortgage share application</h4>
          <div className="col-sm">
            <small className="text-gray-500">Name</small>
            <p>
              {mortgageShareApplication.firstName} {mortgageShareApplication.lastName}
            </p>
          </div>
          <div className="col-sm">
            <small className="text-gray-500">Email</small>
            <p>{mortgageShareApplication.email}</p>
          </div>
          <div className="col-sm">
            <small className="text-gray-500">Phone</small>
            <p>{mortgageShareApplication.phone}</p>
          </div>
        </div>
        <div className="flex flex-wrap">
          <div className="col-sm">
            <small className="text-gray-500">Estimated property value</small>
            <p>${formatNumber(mortgageShareApplication.estimatedPropertyValue)} AUD</p>
          </div>
          <div className="col-sm">
            <small className="text-gray-500">Estimated outstanding mortgage</small>
            <p>${formatNumber(mortgageShareApplication.estimatedOutstandingMortgage)} AUD</p>
          </div>
          <div className="col-sm">
            <small className="text-gray-500">Estimated monthly mortgage</small>
            <p>${formatNumber(mortgageShareApplication.estimatedMonthlyMortgage)} AUD</p>
          </div>
        </div>
        <div className="flex flex-wrap">
          <div className="col-sm">
            <small className="text-gray-500">Date of property purchase</small>
            <p>{formatDate(mortgageShareApplication.dateOfPropertyPurchase)}</p>
          </div>
          <div className="col-sm">
            <small className="text-gray-500">Years left on mortgage</small>
            <p>{mortgageShareApplication.yearsLeftOnMortgage}</p>
          </div>
          <div className="col-sm">
            <small className="text-gray-500">Application status</small>
            <p>{mortgageShareApplication.status}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewStep;
